import React, { FC } from 'react'
import './divider.css'

// UTILITIES
import { flatten } from '@utils/string-helper'


interface Props extends React.HTMLAttributes<HTMLDivElement> {
    children?: React.ReactNode
    margin?: boolean
    align?: 'left' | 'center' | 'right'
}

const Divider: FC<Props> = (props) => {
    const { className: classProps, children, margin = false, align = 'center', ...divProps } = props
    const className = flatten('divider', { margin, [align]: align !== 'center' }, classProps)

    return <div className={className} {...divProps}>{children}</div>
}

export default Divider